import { Link } from '@liveauctioneers/hammer-ui-core/link';

import PageTitle from '@/components/PageTitle/PageTitle';

import PRServicesPageHeaderMeta from './PRServicesPageHeaderMeta';

const PRServicesPage = () => {
    return (
        <div className="mx-auto max-w-[1240px] px-sm pb-lg">
            <PRServicesPageHeaderMeta />
            <div className="[&_h2]:pt-lg [&_h2]:pb-sm [&_h5]:pt-md">
                <PageTitle title="PR Services" />
                <p>
                    LiveAuctioneers PR Services (LAPRS) is a boutique publicity and public relations agency whose sole
                    focus is the antiques, fine art and auction world.
                </p>
                <p>
                    The agency specializes in creating customized and demographically targeted promotional campaigns to
                    publicize upcoming or completed auctions, shows, book releases or product launches to a global
                    audience of editors and readers.
                </p>
                <p>
                    LAPRS is headed by Catherine Saunders-Watson, a respected communications professional who has a
                    stellar 20-year track record as an editor, writer and publicist in the arts sector. Catherine has a
                    thorough understanding of the auction business. She and her experienced team offer services to suit
                    the needs of all auction houses, regardless of size or location.
                </p>
                <p>
                    In cases where a full publicity campaign is not required, clients may opt for a professionally
                    written press release, which they can distribute to their own customer or media list
                </p>

                <div className="flex max-w-full flex-col items-center py-xs [&_div]:mb-xs [&_img]:max-w-full">
                    <img
                        alt="pr illustration"
                        loading="lazy"
                        src="https://p1.liveauctioneers.com/dist/images/pr_illustration.png"
                    />
                </div>

                <h5>
                    <strong>How It Works:</strong>
                </h5>
                <p>
                    After you&apos;ve notified us that you&apos;d like to enlist our services, an editor will contact
                    you to arrange a telephone interview about your auction, antiques show or product. At the time of
                    the actual interview, a request will be made for images and captions (unless your company opts to
                    self-distribute). When the draft release is ready, it will be emailed to you for approval or
                    changes. Upon your approval, the release will be distributed to our highly effective media list, and
                    our web posters will immediately begin uploading it to auction, art and other news sites. Soon you
                    will start to see tangible results, with placements in print publications and on blogs and newspaper
                    websites. Throughout the campaign, LAPRS staff will communicate with you to share news of placements
                    online and in print.
                </p>
                <p>
                    LAPRS is not a mill. Each campaign is a custom production, tailored to suit your company&apos;s
                    particular goals. To ensure quality control, we only undertake a few campaigns at a time. This is
                    why so many clients comment positively about the high level of personal attention they receive from
                    LAPRS staff. The minute we accept a request to create your campaign, LAPRS becomes your
                    company&apos;s PR support team, dedicated to your success and always available to take your call.
                </p>

                <div className="flex max-w-full flex-col items-center py-xs [&_div]:mb-xs [&_img]:max-w-full">
                    <img
                        alt="newspapers"
                        loading="lazy"
                        src="https://p1.liveauctioneers.com/dist/images/prservices_nyt.gif"
                    />
                </div>

                <h5>
                    <strong>Elite campaign, which includes:</strong>
                </h5>
                <ol className="mb-[20px] text-[#0097ba] [&_li]:mt-xs">
                    <li>Our personal management of a publicity campaign from start to finish.</li>
                    <li>
                        We create the press release and captions and distribute the release not only to arts editors but
                        also to daily newspapers, magazines and websites.
                    </li>
                    <li>
                        We will personally liaise with any specialty publications, clubs, museums or other institutions
                        whom you wish for us to contact, and supply them with PR materials.
                    </li>
                </ol>
                <p>
                    When it&apos;s time to publicize your auction, show, book or other antiques or art-related product,
                    you deserve the best — LiveAuctioneers PR Services.
                </p>
                <p>
                    For pricing and additional information contact: Client Services at 888.600.2437 ext. 2 or e-mail{' '}
                    <Link href="mailto:support@liveauctioneers">support@liveauctioneers.com</Link>.
                </p>

                <div className="flex max-w-full flex-col items-center py-xs [&_div]:mb-xs [&_img]:max-w-full">
                    <div>
                        <img
                            alt="Screenshot of CBS TV"
                            loading="lazy"
                            src="https://p1.liveauctioneers.com/dist/images/cbs_screenshot.png"
                        />
                        <img
                            alt="CBS this morning"
                            loading="lazy"
                            src="https://p1.liveauctioneers.com/dist/images/CBSthismorninglogo.png"
                        />
                    </div>
                    <img
                        alt="New York Post article"
                        loading="lazy"
                        src="https://p1.liveauctioneers.com/dist/images/nypost_articles.gif"
                    />
                </div>

                <h5>
                    <strong>Client Testimonials:</strong>
                </h5>
                <p>
                    &quot;
                    <span className="italic">The New York Times</span>, <span className="italic">New York Post</span>,{' '}
                    <span className="italic">CBS This Morning</span>,{' '}
                    <span className="italic">The Huffington Post</span>,{' '}
                    <span className="italic">Associated Press</span>, <span className="italic">The Miami Herald</span>,{' '}
                    <span className="italic">Vogue Italia</span>,{' '}
                    <span className="italic">Canadian-Latin American-German</span> press agencies, print media and
                    websites-blogs-tweets-Facebook entries worldwide… all writing, tweeting and talking about our
                    January 19, 2013, auction and all because LiveAuctioneers PR Services let the world know about it.
                </p>
                <p>
                    <span className="text-black font-bold">
                        The result: our best auction to date, with 690 registered bidders, 568 bids, 186,000 page views,
                        20,000+ visitors and $330,000 in winning bids, and all that just on LiveAuctioneers.com!
                    </span>{' '}
                    That doesn&apos;t include, as a result of your PR work, the record 400+ in-house bidders, phone
                    bidders or left bids that all contributed to a million-dollar auction. The sheer numbers, in terms
                    of sales and bidders, were way beyond our expectations, but you gave us even more, something you
                    can&apos;t pay for… EDITORIAL, exposing our auction house all over the world!
                </p>
                <p>
                    You shared our passion about the auction, worked hard (even on nights and weekends) and relentlessly
                    pursued every possible PR lead. We really don&apos;t know how to thank you; you have energized and
                    set the new standard for Palm Beach Modern Auctions.
                </p>
                <p>
                    I would recommend your services to any auction house looking to increase their sales or company
                    presence in the auction world.&quot;
                </p>
                <h5>
                    <strong>
                        —Wade Terwilliger, President,{' '}
                        <Link href="/auctioneer/1045/palm-beach-modern-auctions/">Palm Beach Modern Auctions</Link>
                    </strong>
                </h5>
                <p>
                    &quot;We are writing to commend Catherine Saunders-Watson for a job well done. Not only is Catherine
                    thorough in her work, she pays meticulous attention to detail, which is crucial to the success of
                    our publicity. Her wide range of knowledge has been an asset in getting our company the maximum
                    amount of exposure. The results we have seen as a result of her efforts have been
                    overwhelming.&quot;
                </p>

                <h5>
                    <strong>
                        —Stephen D&apos;Atri, Owner,{' '}
                        <Link href="/auctioneer/1353/sterling-associates/">Sterling Associates Inc.</Link>
                    </strong>
                </h5>
                <p>
                    &quot;This was our first time using LiveAuctioneers PR services and we were a little intimidated by
                    the process. To our relief absolutely no need to be apprehensive. Catherine at LiveAuctioneers
                    marketing walked us thru the whole process from start to finish. She gave us quite an insight to the
                    benefits of sending out a press release and made some great recommendations on how to market our
                    auction. Our annual auction almost doubled in sales from the previous year and we saw a greater
                    number of registered bidders along with a higher sell-thru rate due to the referred targeted
                    clientele. We will definitely be using these services in the future. Thank you, Catherine, and the
                    whole team at LiveAuctioneers.&quot;
                </p>

                <h5>
                    <strong>
                        —Paul Sabesky, Owner/CEO{' '}
                        <Link href="/auctioneer/546/governmentauction/">Government Auction</Link>
                    </strong>
                </h5>

                <div className="flex max-w-full flex-col items-center py-xs [&_div]:mb-xs [&_img]:max-w-full">
                    <img
                        alt="Speech bubbles about PR"
                        loading="lazy"
                        src="https://p1.liveauctioneers.com/dist/images/pr_speechbubbles.gif"
                    />
                </div>

                <p>
                    &quot;It&apos;s been a week since our New Year&apos;s Auction and we have been struggling to find
                    the right words to describe our first experience with LiveAuctioneers PR Services. Fabulous? Beyond
                    expectations? Incredible? Catherine Saunders-Watson is the best thing that&apos;s happened to our
                    auction. Catherine has such a way with words, insight of the auction market, and creativity. It went
                    so far beyond our imagination and expectations — we could not believe the response, not just the
                    United States but around the world. We sold $70,000 to Russian bidders and close to $80,000 to
                    China, in addition to the United States and other countries.
                </p>
                <p>
                    We were on TV, radio, in newspapers and magazines, on collector sites, the Internet and on top of
                    the search engines. Fabulous! We had over 70,000 hits on LiveAuctioneers, alone, before the auction.
                    Beyond expectations! Just before the auction we took a late consignment and mentioned it to
                    Catherine. Two days later, it was picked up by major collector sites. Incredible! For Don Presley
                    Auctions, Catherine Saunders-Watson is truly &quot;A SLICE OF HEAVEN.&quot; Anyone who wishes to do
                    so can call me personally for a recommendation. My wife Kimberly Presley and I sincerely thank you
                    and look forward to working with you at our next auction.&quot;
                </p>

                <h5>
                    <strong>
                        —Don and Kimberly Presley,{' '}
                        <Link href="/auctioneer/1144/don-presley-auction/">Don Presley Auctions</Link>
                    </strong>
                </h5>
                <p>
                    &quot;We had a fine sale thanks to your excellent PR, which brought Channels 6 and 10 from
                    Philadelphia, and the Morning Call newspaper from Allentown. The Daily Local covered us three times,
                    including a Sunday morning above-the-fold front-page story. All in all, a great job!&quot;
                </p>

                <h5>
                    <strong>
                        —William H. Bunch,{' '}
                        <Link href="/auctioneer/1144/don-presley-auction/">Auctioneer & Appraiser</Link>
                    </strong>
                </h5>
                <p>
                    &quot;We had a fine sale thanks to your excellent PR, which brought Channels 6 and 10 from
                    Philadelphia, and the Morning Call newspaper from Allentown. The Daily Local covered us three times,
                    including a Sunday morning above-the-fold front-page story. All in all, a great job!&quot;
                </p>

                <h5>
                    <strong>
                        —Chris Featherston,{' '}
                        <Link href="/auctioneer/21/austin-auction-gallery/">Austin Auction Gallery</Link>
                    </strong>
                </h5>
                <p>
                    &quot;I want to let you know that my first experience with LiveAuctioneers.com PR services went way
                    beyond my expectations!
                </p>
                <p>
                    Catherine Saunders-Watson is a dream to work with. She is extremely responsive, incredibly fast and
                    has excellent creative insight. Catherine put me at ease immediately and always made me feel as if
                    our auction was the most important item on her agenda.
                </p>
                <p>
                    The pre-auction press release written by Catherine was widely received by editors, which enabled us
                    to reach a huge audience and achieve a record breaking price for a Black Forest rarity.
                </p>
                <p>
                    Every investment that we&apos;ve made using LiveAuctioneers.com services has been worth it, and I am
                    now 100% sold on the new PR service as well.
                </p>
                <p>
                    Thank you so much for another success brought about by the fabulous team at
                    LiveAuctioneers.com!&quot;
                </p>
                <h5>
                    <strong>
                        —Kathleen Pica,{' '}
                        <Link href="/auctioneer/170/auctions-neapolitan/">Auctions Neapolitan &amp; Gallery</Link>
                    </strong>
                </h5>
                <p>
                    &quot;Our decision to use LiveAuctioneers PR Services to promote our July auction resulted in our
                    best auction yet on LiveAuctioneers. We had our highest number of online bids and bidders, which
                    made a big impact on sales results for both online and onsite hammer prices. It was easy working
                    with LAPRS's professional staff to get the word out about our auction, and we were especially
                    pleased with the postsale press release coverage. Our sale was a hit, and our decision to enlist the
                    expertise of LAPRS was a big part of the success.&quot;
                </p>

                <h5>
                    <strong>
                        —Barbara Frasher, President,{' '}
                        <Link href="/auctioneer/1023/frashers-doll-auction/">Frasher&apos;s Doll Auctions, Inc.</Link>
                    </strong>
                </h5>
                <p>
                    &quot;Live Auctioneers PR services pushed our auction to the next level. Getting a press release
                    published in the antiques, art and collecting media brought our auction new bidders from all over
                    the planet. Catherine helped us write a fantastic press release, gave us advice on media relations
                    and got us the results we needed. Thank you for everything, and we will be using your service
                    again!&quot;
                </p>

                <h5>
                    <strong>
                        —Ryan Brechlin, Auctioneer,{' '}
                        <Link href="/auctioneer/1163/nest-egg-auctions/">Nest Egg Auctions</Link>
                    </strong>
                </h5>
                <p>
                    &quot;I wanted to take a moment to write to you about the exceptional service I continue to receive
                    working with Catherine Saunders-Watson, who heads LiveAuctioneers PR Services. Not only does she do
                    everything one would expect from a first-rate PR person, I consider her a partner in our media
                    success throughout our campaigns. Most PR people I&apos;ve worked with in the past write the
                    release, submit it, and that&apos;s it. Not Catherine. She really cares about &apos;who&apos; we
                    are, &apos;what&apos; we sell and &apos;how best&apos; to market us across a variety of media
                    platforms. Because of her stellar work and exceptional writing, we consistently get amazing
                    placements, both online and in print. It doesn&apos;t hurt that we sell art that is truly amazing,
                    but Catherine knows exactly &apos;how&apos; to write to get attention from the folks who matter in
                    the press. She also writes from her heart, in a way that elevates our art to new levels and compels
                    people to read more about us (and hopefully click-thru to learn more). Every time I work with
                    Catherine it is better than the time before.
                </p>
                <p>
                    As a further testament to her dedication, Catherine keeps in touch with me after every sale to see
                    how things went and to look for ways we might be able to make things even better next time. As I
                    tell my colleagues, Catherine is my secret weapon, and I wouldn&apos;t know what to do without her.
                    I cannot thank her enough for all the stellar placements she was able to get for us, both here and
                    abroad.&quot;
                </p>

                <h5>
                    <strong>
                        — Teresa Dodge, Executive Director,{' '}
                        <Link href="/auctioneer/1103/antiquities-saleroom/">
                            Artemis Gallery Ancient Art and Antiquities-Saleroom.com
                        </Link>
                    </strong>
                </h5>
                <p>
                    &quot;We are most grateful for the expert advice, support and dedication Catherine Saunders-Watson
                    has provided us in promoting our auctions over the years. Her enthusiasm, hard work, insight and
                    team spirit are infectious and bring first-rate results from LiveAuctioneers PR Services. She is
                    truly a gem to work with and a valuable asset to Live Auctioneers.&quot;
                </p>

                <h5>
                    <strong>
                        — Mary Dowd, Co-Owner,{' '}
                        <Link href="/auctioneer/251/myers-fine-art/">
                            Myers Fine Art &amp; Antiques Auction Gallery
                        </Link>
                    </strong>
                </h5>
                <p>
                    &quot;We have worked with LAPRS on two auction campaigns — both times with stellar results, and cost
                    effectively. Catherine Saunders-Watson and her team immediately understood what we needed and were
                    able to deliver a wide variety of regional, national and international media coverage. I have no
                    doubt that their efforts had a major impact on each sale&apos;s success&quot;
                </p>

                <h5>
                    <strong>
                        — George Jevremovic, President,{' '}
                        <Link href="/auctioneer/1459/material-culture/">Material Culture</Link>
                    </strong>
                </h5>
                <p>
                    &quot;Catherine is such a pleasure to work with. She is a wonderful person and truly goes the extra
                    mile for her clients. She continues to impress us with her integrity, creative thinking and
                    incredible reach with regard to resources and contacts in our specific category. Once the PR started
                    rolling we were informed regularly with links and updates to news sources that were picking up our
                    article. As soon as we thought she was done (and were thrilled with the results), more would come
                    pouring in! We couldn&apos;t be happier with Catherine and LiveAuctioneers PR Services. It will
                    certainly be a staple of our auction model long into the future.&quot;
                </p>

                <h5>
                    <strong>
                        —Gabriel Vandervort, Owner,
                        <Link href="/auctioneer/1026/ancient-resource-llc/"> Ancient Resource, LLC</Link>
                    </strong>
                </h5>
                <p>
                    &quot;We hired Catherine&apos;s (LAPRS) services for our December 2015 auction. Catherine treated us
                    very well and carefully walked us through all her suggestions for a successful auction marketing
                    campaign as well as explaining all the things she would do from her end. Catherine made it easy to
                    communicate and understand the process, and she delivered great results! I would recommend LAPRS to
                    anyone whose auction has a story to tell.&quot;
                </p>
            </div>
        </div>
    );
};

export default PRServicesPage;
